import { makeStyles, Theme } from "@material-ui/core";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

interface IStylesProps {
  backgroundColor: string;
}

export default makeStyles<Theme, IStylesProps>((theme: MuiTheme) => ({
  iconContainer: {
    minWidth: 70,
    minHeight: 60,
    borderRight: "1px solid #000000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      border: "none"
    },
    backgroundColor: ({ backgroundColor }) =>
      backgroundColor ? `#${backgroundColor}` : "transparent"
  },
  facilityIcon: {
    fontSize: 36
  }
}));
